/**
 * Human-readable labels for raw SQL-view column identifiers.
 *
 * The datagrid headers, the row-details drawer and the 3D colouring legend all name the same
 * columns, so they must spell them the same way: the widget's authored display name when it has
 * one, else a camelCase -> Title Case rendering of the raw identifier.
 *
 * PURE module: no Vuex, no components.
 */

/**
 * Raw column identifier -> Title Case (the datagrid header rendering).
 *
 * Splits on separators and on camelCase boundaries only. Splitting before EVERY capital would
 * shatter an acronym column into letters ('CMLTYPE' -> 'C M L T Y P E'), which is worse than the
 * raw identifier the caller was trying to improve on; an acronym is left whole instead, and an
 * acronym followed by a word still splits ('TMLReading' -> 'TML Reading').
 */
export function formatHeaderName(key) {
  return String(key)
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/^./, str => str.toUpperCase())
    .trim();
}

/** The authored display name for a column, falling back to formatHeaderName. */
export function columnDisplayName(key, displayNames) {
  if (key == null) return '';
  const names = displayNames || {};
  return names[key] || formatHeaderName(key);
}
